import axios from 'axios';

// URL do backend: use REACT_APP_API_URL (ex: http://localhost:5000) ou só a porta com REACT_APP_API_PORT
const API_URL = process.env.REACT_APP_API_URL;
const API_PORT = process.env.REACT_APP_API_PORT;

if (API_URL) {
  axios.defaults.baseURL = API_URL;
  console.log('🔗 API URL configurada:', API_URL);
} else if (process.env.NODE_ENV === 'production') {
  const frontendUrl = window.location.origin;
  if (frontendUrl.includes('sistemajoga10-front')) {
    axios.defaults.baseURL = frontendUrl.replace('sistemajoga10-front', 'sistemajoga10-back');
    console.log('🔗 API URL inferida:', axios.defaults.baseURL);
  } else {
    axios.defaults.baseURL = frontendUrl;
    console.warn('⚠️ REACT_APP_API_URL não configurado. Usando:', frontendUrl);
  }
} else {
  const port = API_PORT || '3001';
  axios.defaults.baseURL = `http://localhost:${port}`;
  console.log('🔗 Modo desenvolvimento: usando', axios.defaults.baseURL);
}

export default axios;

